<script>
import axios from "axios";
import ErrorAlert from "@/components/errorAlert";
import { toast, variants } from "@/helpers/toaster";

export default {
  name: "ChangePasswordModal",
  components: {
    ErrorAlert,
  },
  props: {
    administratorId: String,
    employeeId: String,
    buttonClass: String,
  },
  data() {
    return {
      showModal: false,
      changePasswordForm: {
        fields: {
          new_password: {
            value: '',
            error: false,
          },
          password_confirmation: {
            value: '',
            error: false,
          },
        }
      }
    }
  },
  computed: {
  },
  mounted() {
  },
  watch: {
    showModal(v) {
      this.$store.commit('errorBag/CLEAR');
    }
  },
  methods: {
    close() {
      this.showModal = false;
      this.$emit('onClose');
      this.$emit('closed');
    },
    async ok() {
      this.$store.commit('loader/START_LOADING');

      let route = `super-admin/`

      if (this.administratorId) {
        route += `administrators/` + this.administratorId;
      } else {
        route += `employees/` + this.employeeId;
      }

      route += '/update-password';

      await axios.put(route, {
        password: this.changePasswordForm.fields.new_password.value,
        password_confirmation: this.changePasswordForm.fields.password_confirmation.value,
      }).then(() => {
        this.$emit('onSubmit');
        toast('Uspešna izmena lozinke.', variants.SUCCESS)
        this.close();
      }).finally(() => {
        this.$store.commit('loader/END_LOADING')
      });
    },
  },
}
</script>

<template>
  <span>
    <b-button :class="buttonClass" @click="showModal = true" variant="primary" class="ml-2" >Promeni lozinku</b-button>
    <b-modal @hidden="close" v-model="showModal" title="Izmeni lozinku" size="md" centered hide-footer>
      <ErrorAlert></ErrorAlert>

      <form ref="changePasswordForm" autocomplete="off" @submit.prevent="complete">
        <div class="form-group row mb-3">
          <label class="col-12 col-md-5 col-form-label" for="new_password">Nova lozinka:</label>
          <div class="col-12 col-md-7">
            <input
                id="new_password"
                type="password"
                autocomplete="new-password"
                class="form-control"
                @input="changePasswordForm.fields.new_password.error = false"
                :class="{'is-invalid': changePasswordForm.fields.new_password.error}"
                name="new_password"
                v-model="changePasswordForm.fields.new_password.value"
            />
          </div>
        </div>

        <div class="form-group row mb-3">
          <label class="col-12 col-md-5 col-form-label" for="password_confirmation">Ponovi novu lozinku:</label>
          <div class="col-12 col-md-7">
            <input
                id="password_confirmation"
                type="password"
                autocomplete="new-password"
                class="form-control"
                @input="changePasswordForm.fields.password_confirmation.error = false"
                :class="{'is-invalid': changePasswordForm.fields.password_confirmation.error}"
                name="current_password"
                v-model="changePasswordForm.fields.password_confirmation.value"
            />
          </div>
        </div>

        <div class="form-group text-right mt-3">
          <div class="row align-items-middle justify-content-middle">
            <div class="col-12">
              <button class="btn btn-outline-secondary px-4 mr-2" @click="close">
                Otkaži
              </button>
              <b-button @click="ok" variant="primary" class="btn px-4 ml-2" >Snimi</b-button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
  </span>
</template>
<style scoped>
.price-item {
  background-color: #fbfbfb;
  box-shadow: 0px 0px 0px #ffffff;
  border-radius: 4px;
}

.tab-section {
  border: 0px;
  border-radius: 0px;
  border-bottom: 1px solid #f6f6f6;
  margin-bottom: 0px;
  margin-top: 0px;
}

.tab-section:last-child {
  border: 0px;
}

.price-container {
  width: 170px;
}

.sum-section {
  margin-right: 5px;
  border-top: 2px solid #f6f6f6;
  padding-top: 10px;
}

.total-price {
  position: relative;
}

.tab-section h5 {
  font-size: 0.9rem;
}

.pricing-header-row {
  border-bottom: 2px solid #f6f6f6;
  border-radius: 2px;
}

.social-image-container {
  height: 30px;
}

.autocomplete {
  width: 100%;
}
</style>
